import React, { ChangeEvent, useContext, useEffect, useRef, useState } from 'react'
import IconButton from '../../icons/IconButton';
import emojiData from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import { Button, ClickAwayListener, Dialog, DialogTitle, Fade, Popper, TextareaAutosize, Tooltip } from '@mui/material';
import GIcon from "../GIcon"
import AudioVisualizer from "./AudioRecorder"
import { Context } from '../ChatPanel/ChatContext';
import { IMessage, IMessagePost, ITypeArea, TopicTypes } from '../../types';
import { useSocket } from '../../atoms/socket';
import { useAtomInstance, useAtomState, useAtomValue } from '@zedux/react';
import { messageReceiverAtom } from '../../atoms/messageReceiverAtom';
import { selectedFilterAtom, NO_FILTER } from '../../atoms/filterAtoms';
import { FilterTypes } from '../../types';
import cx from 'classix';
import faData from './emojiFa.json'
import useModalState from '@src/library/useModalState';
import { fileTypeFromBlob } from 'file-type';
import { typeAreaAtom } from '@src/atoms/typeAreaAtoms';


//disabled if no active topic
export default function TypeArea({ topic, disabled }: ITypeArea) {

    const socket = useSocket()
    const { userInfo, setError, context, helpMode = false } = useContext(Context)

    const { typedText: typed, imagePreview, fileData, editMode, replyMode } = useAtomValue(typeAreaAtom, [context, topic.topic_id])
    const { setFileData, setImagePreview, setTypedText: setTyped, setEditMode, setReplyMode } = useAtomInstance(typeAreaAtom, [context, topic.topic_id]).exports

    const [selectedFilter, setSelectedFilter] = useAtomState(selectedFilterAtom, [context, topic.topic_id])


    const isFile = fileData != null && imagePreview == null
    // const [typed, setTyped] = useState('')
    // const [imgPreview, setImagePreview] = useState('')
    // const [fileData, setFileData] = useState<File | null>(null)
    // const [isFile, setIsFile] = useState(false)


    const [showError, setShowError] = useState(false)

    // Totally disable
    const totallyDisabled = (socket == null || !socket.connected || disabled)

    const totallyInvisible = (topic.topic_type == TopicTypes.CHANNEL && (topic.admin_id !== userInfo.userId && (topic.admin_id !== userInfo.bossId || userInfo.bossId != 0)))


    const [showEmoji, setShowEmoji] = useState(false)
    // const [isFileDialogOpen, openFileDialog, closeFileDialog] = useModalState(false)
    const [showAttachmentTypePicker, setShowAttachmentTypePicker] = useState(false)
    const [recordingAudio, setRecordingAudio] = useState(false)
    const [shouldSendTyping, setShouldSendTyping] = useState(true)
    // const [pickTopic, setPickTopic] = useState(false)
    const { sendMessage, editMessage } = useAtomInstance(messageReceiverAtom, [context]).exports

    const popperMessage = (replyMode || editMode || null) as IMessage | null

    const emitClearTyping = () => {
        socket?.emit("typing", {
            user_id: userInfo?.userId,
            topicId: topic.topic_id,
            isTyping: false,
            event: '',
        })
    }

    const emitTyping = (event: string, autoClear: boolean = true) => {
        clearTimeout(timeoutRef.current);

        if (shouldSendTyping) {
            socket?.emit("typing", {
                user_id: userInfo?.userId,
                topicId: topic.topic_id,
                isTyping: true,
                event
            })
            setShouldSendTyping(false)
        }
        // @ts-ignore
        if (autoClear) {
            timeoutRef.current = setTimeout(() => {
                emitClearTyping()
                setShouldSendTyping(true)
            }, 3000)
        }
    }


    const sendCurrentTyped = async () => {
        if ((typed.length != 0 || fileData != null) && !totallyDisabled) {
            if (editMode) {
                editMessage(editMode.message_id, topic.topic_id, typed)
                setTyped('')
            } else {
                console.log('send msg', fileData, fileData?.type)

                const detectedMime = fileData != null ? await fileTypeFromBlob(fileData) : null
                const mime = fileData != null ? (fileData.type || detectedMime?.mime || 'application/octet-stream') : null

                sendMessage({
                    topic_id: topic.topic_id,
                    text: typed,
                    context: context,
                    filename: fileData?.name ?? null,
                    forward_id: null,
                    mime_type: mime,
                    reply_id: replyMode ? replyMode.message_id : null,
                    created_at: Date.now(),
                    file_content: fileData ?? null,
                } as IMessagePost)
                // emit "sending..." status
                if (fileData && mime) {
                    const typingText = mime.startsWith("audio") ? "در حال ارسال ویس/صدا 🎙" :
                        (mime.startsWith('image') ? "در حال ارسال عکس 🖼️" :
                            (mime.startsWith('video') ? "در حال ارسال ویدئو 📹" : "در حال ارسال فایل 📄")
                        )
                    emitTyping(typingText, true)
                }
                setTyped('')
            }
            setEditMode(null)
            setReplyMode(null)
            setFileData(null)
            setImagePreview(null)
        } else {
            setShowError(true)
        }
    }

    const [emojiAnchorEl, setEmojiAnchorEl] = useState<null | HTMLElement>(null);
    const fileAnchorEl = useRef(null)
    const timeoutRef = useRef<number>(0)

    const handleEmojiClick = (event: React.MouseEvent<HTMLElement>) => {
        setEmojiAnchorEl(event.currentTarget);
        setShowEmoji((previousOpen) => !previousOpen)
    }

    const emojiId = showEmoji ? 'transition-popper' : undefined;
    const fileId = showAttachmentTypePicker ? 'transition-popper' : undefined;

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (typed.length != 0 && e.key === "Enter" && !e.shiftKey) {
            e.preventDefault()
            e.stopPropagation()
            sendCurrentTyped()
            return false
        }
    }

    function selectFile(event: ChangeEvent<HTMLInputElement>): void {

        if (event.target.files) {
            setFileData(event.target.files[0])
        } else {
            setError("خطای اپلود")
        }
        setShowAttachmentTypePicker(false)
    }
    async function showImageDialog(event: ChangeEvent<HTMLInputElement>) {
        if (!event.target.files) {
            setError("خطای اپلود")
            return
        }

        const file = event.target.files[0]
        if (!file) {
            setError("خطای اپلود")
            return
        }

        try {
            setImagePreview(file)
        } catch (error) {
            setError(error instanceof Error ? error.message : "خطای اپلود")
            return
        }
        setShowAttachmentTypePicker(false)
    }

    return (
        <div className='flex flex-col content-end bg-stone-100 chat-type-area pb-2'>
            {selectedFilter.type !== FilterTypes.NO_FILTER ? <div className='flex flex-row justify-center items-center p-4 text-xl'>
                <div className='mx-2' >
                    در حال نمایش   محتوای فیلتر شده
                </div>
                <Button onClick={() => setSelectedFilter(NO_FILTER)} className='mx-2' variant='contained' color='success'>انصراف</Button>
            </div> :
                (!!topic && !totallyInvisible) ? <>
                    <Dialog open={fileData != null} onClose={() => setFileData(null)} className="rounded-2xl" disableScrollLock={true}>
                        <div className="flex flex-col justify-center items-center content-center p-4">
                            <DialogTitle className="font-bold"><div>ارسال {isFile ? "فایل" : "تصویر"}</div></DialogTitle>
                            {isFile ? <GIcon name='draft' className="text-9xl" /> : fileData?.type?.startsWith('video/') ? (
                                <video controls src={imagePreview ?? undefined} className='w-auto max-w-[90dvw] max-h-[calc(65dvh-7rem)] object-contain' />
                            ) : (
                                <img src={imagePreview ?? undefined} alt="Preview" className='w-auto max-w-[90dvw] max-h-[calc(65dvh-7rem)] object-contain' />
                            )}
                            <p>{fileData?.name}</p>
                            <input value={typed} onChange={(e) => { setTyped(e.target.value) }} type="text" className='bg-input/5 focus-within:bg-input/15 border border-input/20 focus-within:border-input/30 border-solid rounded outline-0 w-full text-base' placeholder={`درج عنوان برای ${isFile ? "فایل" : "تصویر"} ...`} />
                            <div className="flex gap-4 mt-1">
                                <Button variant='outlined' sx={{ fontFamily: 'Vazir' }} color='error' onClick={() => {
                                    setImagePreview(null)
                                    setShowAttachmentTypePicker(false)
                                }}>انصراف</Button>
                                <Button variant='contained' sx={{ fontFamily: 'Vazir' }} className='bg-sky-500' onClick={async (e) => {
                                    e.preventDefault()
                                    sendCurrentTyped()
                                    setShowAttachmentTypePicker(false)
                                }
                                }>ارسال</Button>
                            </div>
                        </div>
                    </Dialog>
                    <div className="flex justify-between mb-2">
                        <Popper className="shadow-md chat-root" id={fileId} open={showAttachmentTypePicker} anchorEl={fileAnchorEl.current} placement="top-start" transition sx={{ zIndex: 2100 }}>
                            {({ TransitionProps }) => (
                                <Fade {...TransitionProps} timeout={350}>
                                    <div className={`flex flex-col justify-end items-start pr-2 `}>
                                        <ClickAwayListener onClickAway={() => { setFileData(null); setShowAttachmentTypePicker(false) }}>
                                            <div className='bg-white p-3 border border-stone-200/60 rounded-2xl'>
                                                <label className='flex flex-row items-center hover:bg-stone-300 p-2 rounded cursor-pointer'>
                                                    <input hidden onChange={showImageDialog} type='file' accept='.jpg, .jpeg, .png, .gif, .webp, .avif, .mp4, .mkv, .wmv, .mov'
                                                        onClick={(e) => {
                                                            (e.target as HTMLInputElement).style.background = "var(--color-stone-400)";

                                                        }} className='flex flex-row items-start p-1 rounded-md text-black text-lg' />
                                                    <GIcon name="image" />
                                                    <div>
                                                        عکس یا ویدیو
                                                    </div>
                                                </label>
                                                <label className='flex flex-row items-center hover:bg-stone-300 p-2 rounded cursor-pointer'>
                                                    <input hidden onChange={selectFile} type='file' accept='*'
                                                        onClick={(e) => {
                                                            (e.target as HTMLInputElement).style.background = "var(--color-stone-400)";
                                                        }
                                                        } className='flex flex-row items-start p-1 rounded-md text-black text-lg' />
                                                    <GIcon name='insert_drive_file' className="material-icons-outlined" />
                                                    <div>
                                                        فایل
                                                    </div>
                                                </label>
                                            </div>
                                        </ClickAwayListener>
                                    </div>
                                </Fade>
                            )}
                        </Popper>
                        <Popper
                            modifiers={[
                                {
                                    name: "offset",
                                    options: {
                                        offset: [0, 10],
                                    },
                                },
                            ]}
                            sx={{
                                zIndex: '2100'
                            }}
                            className="shadow-md overflow-hidden chat-root" id={emojiId} open={showEmoji} anchorEl={emojiAnchorEl} placement="top-start" transition>
                            {({ TransitionProps }) => (
                                <Fade {...TransitionProps} timeout={350}>
                                    <div>
                                        <Picker previewPosition="none"
                                            locale="fa" theme="light" icons="outline"
                                            data={emojiData} onEmojiSelect={(data: any) => setTyped(typed + data.native)}
                                            i18n={faData}

                                        />
                                    </div>
                                </Fade>
                            )}
                        </Popper>

                    </div>
                    {popperMessage !== null &&
                        <div className='flex flex-row items-center'>
                            <div className='flex flex-col bg-stone-300 mx-4 px-2 py-1 border-r-2 border-r-stone-700 text-xl grow'>
                                <div className='text-black text-sm'><span className='font-serif'>&ldquo;</span>{popperMessage.sender_is_me ? "من " : popperMessage.sender_username}<span className='font-serif'>&rdquo;</span></div>
                                <div className='text-sm lg:text-lg line-clamp-1 lg:line-clamp-2'>{popperMessage.text}</div>
                                {popperMessage.mime_type && popperMessage.mime_type.startsWith("video") && <div className='mt-1'>
                                    <video controls className='m-1 max-w-sm max-h-28'>
                                        <source src={popperMessage.attachment ?? ''} type={popperMessage.mime_type} />
                                        مرورگر شما از پخش این فایل پشتیبانی نمی‌کند.
                                    </video>
                                </div>}
                                {popperMessage.mime_type && popperMessage.mime_type.startsWith("image") && <div className='mt-1'>
                                    <img className='m-1 max-w-xs max-h-18' src={popperMessage.attachment ?? ''} alt="Preview" />
                                </div>}
                                {
                                    popperMessage.mime_type && popperMessage.mime_type.startsWith("audio") && <div className='mt-1'>
                                        <audio controls className='w-full'>
                                            <source src={popperMessage.attachment ?? ''} type={popperMessage.mime_type} />
                                            مرورگر شما از پخش این فایل پشتیبانی نمی‌کند.
                                        </audio>
                                    </div>
                                }
                                {
                                    popperMessage.mime_type && !popperMessage.mime_type.startsWith("audio") && !popperMessage.mime_type.startsWith("image") && !popperMessage.mime_type.startsWith("video") && <div className='flex flex-row items-center gap-x-2 mt-1'>
                                        <GIcon name='insert_drive_file' className="material-icons-outlined" />
                                        <span className='text-black text-sm'>{popperMessage.attachment}</span>
                                    </div>
                                }
                            </div>
                            <GIcon className='ml-3 cursor-pointer' onClick={() => { setReplyMode(null); setEditMode(null); setTyped('') }} name='close' />
                        </div>
                    }
                    {/* {
                        !!forwardMessage &&
                        <div className='flex flex-row items-center'>
                            <div className='flex flex-col bg-stone-300 mx-4 px-2 py-1 border-r-2 border-r-stone-700 text-xl grow'>
                                <div className='text-black text-sm'><span className='font-serif'>&ldquo;</span>{forwardMessage.sender_is_me ? "من " : (forwardMessage as IMessage).sender_username}<span className='font-serif'>&rdquo;</span></div>
                                <div className='text-[1em]'>{forwardMessage.text}</div>
                                {forwardMessage.mime_type && forwardMessage.mime_type.startsWith("image") && <div className='mt-1'>
                                    <img className='m-1 max-w-xs max-h-18' src={forwardMessage.attachment ?? ''} alt="Preview" />
                                </div>}
                            </div>
                            <GIcon className='ml-3 touch-manipulation cursor-pointer select-none'  name='close' />
                        </div>
                    } */}
                    <div className='flex flex-row justify-center items-end p-2 w-full grow'>
                        <div className={`bg-white p-2 flex flex-row grow ${showError ? "border-red-500" : "border-transparent"} items-center content-center rounded-lg border gap-x-1`}>
                            {/* Audio Record Button and Visualizer */}
                            <Tooltip slots={{
                                transition: Fade,
                            }}
                                slotProps={{
                                    transition: { timeout: 600 },
                                }} placement='top' arrow title="پیام صوتی">
                                <AudioVisualizer
                                    onClick={(v) => setRecordingAudio(v)}
                                    recording={recordingAudio}
                                    replyMode={replyMode}
                                    setReplyMode={setReplyMode}
                                />
                            </Tooltip>

                            {/* Typing Area */}
                            <TextareaAutosize
                                className={
                                    cx(
                                        'grow resize-none p-0 border-0 focus:border-0 focus:outline-none disabled:text-stone-400 transition-none',
                                        recordingAudio && 'hidden'
                                    )
                                }
                                maxRows={8}
                                placeholder='پیام خود را بگذارید ...'
                                value={typed}
                                onChange={e => {
                                    if (showError) {
                                        setShowError(false)
                                    }

                                    emitTyping('در حال نوشتن...')
                                    setTyped(e.target.value);

                                }}
                                onKeyDown={handleKeyDown}
                                disabled={totallyDisabled}
                                style={{ border: "none", outline: "none", backgroundColor: "transparent", resize: "none", fontSize: 14 }}
                                wrap='soft'
                                minRows={1}
                            />

                            {recordingAudio ? null :
                                <>
                                    <Tooltip slots={{
                                        transition: Fade,
                                    }}
                                        slotProps={{
                                            transition: { timeout: 600 },
                                        }} placement='top' arrow title="شکلک">
                                        <ClickAwayListener onClickAway={() => setShowEmoji(false)}>
                                            <GIcon name="sentiment_satisfied"
                                                className="self-end hover:text-sky-500 touch-manipulation cursor-pointer select-none"
                                                onClick={handleEmojiClick} />
                                        </ClickAwayListener>
                                    </Tooltip>
                                    {!helpMode && <Tooltip slots={{
                                        transition: Fade,
                                    }}
                                        slotProps={{
                                            transition: { timeout: 600 },
                                        }} placement='top' arrow title="فایل">
                                        <GIcon name="attach_file" ref={fileAnchorEl} onClick={() => setShowAttachmentTypePicker(true)} className="self-end hover:text-sky-500 touch-manipulation cursor-pointer select-none" />
                                    </Tooltip>}
                                    <IconButton
                                        disabled={totallyDisabled || typed.length == 0}
                                        className={`transition-colors cursor-pointer rotate-180 duration-300 stroke-white self-end ${typed == '' || totallyDisabled ? "fill-dark-grey" : "text-sky-500"} text-xs disabled:dark-grey `}
                                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                            e.preventDefault()
                                            sendCurrentTyped()
                                        }}
                                    />
                                </>
                            }
                        </div>
                    </div>
                </> : null
            }
        </div>
    )
}
